






















import { Vue, Component } from 'vue-property-decorator';
import { TranslateResult } from 'vue-i18n';
import i18n from '@/plugins/i18n';
import UiBadgeComponent from '@/app/shared/components/ui/ui-badge-component.vue';
import UiStatusBarComponent from '@/app/shared/components/ui/ui-status-bar-component.vue';

@Component({
  components: {
    UiBadgeComponent,
    UiStatusBarComponent
  }
})
export default class CongratsComponent extends Vue {
  public competenceData: any[] = [
    {
      id: '1',
      title: 'Termékismeret',
      percentage: 45
    },
    {
      id: '2',
      title: 'Ügyfélmanagement',
      percentage: 57
    }
  ];

  public t(key: string): TranslateResult {
    return i18n.t(key);
  }
}
